import React from "react";
import { ShieldCheck, Star, FileText, ClipboardCheck, MapPin } from "lucide-react";
const trustIndicators = [{
  title: "5+ years experience",
  icon: ShieldCheck
}, {
  title: "50+ 5-star reviews",
  icon: Star
}, {
  title: "Reports within 24 hours",
  icon: FileText
}, {
  title: "Insurance inspection experience",
  icon: ClipboardCheck
}, {
  title: "Local South Florida expertise",
  icon: MapPin
}];
export default function WhyChooseTrustedInspections() {
  return <section id="why-choose-trusted-inspections" className="bg-card border-y border-border py-5 lg:py-6">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="flex flex-wrap items-center justify-center gap-x-8 gap-y-4 lg:justify-between">
          {trustIndicators.map((indicator, i) => {
          const Icon = indicator.icon;
          return <div key={i} data-index={i} className="flex items-center gap-3 text-foreground">
                <div className="flex size-8 shrink-0 items-center justify-center rounded-lg bg-primary/10 text-primary">
                  <Icon className="size-4.5 stroke-[2]" />
                </div>
                <span className="text-sm font-semibold tracking-tight text-foreground whitespace-nowrap">
                  {indicator.title}
                </span>
              </div>;
        })}
        </div>
      </div>
    </section>;
}